exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-artikel {\r\n    border: 1px border-style solid black;\r\n    border-spacing: 5px;\r\n} \r\n\r\n.table-zeile-left {\r\n    border: 1px border-style solid black;\r\n    border-spacing: 5px;\r\n    text-align: left;\r\n} \r\n\r\ntable {\r\n    font-family: arial, sans-serif;\r\n    width: 100%;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid blue;\r\n    text-align: left;\r\n    padding: 8px;\r\n}\r\n\r\ntr:nth-child(even) {\r\n    background-color: #dddddd;\r\n}\r\n\r\ntr.selected {\r\n    background-color: grey;\r\n}\r\n\r\n.ui.items>.item.selected {\r\n  border: 1px solid rgba(163, 51, 200, 0.41);\r\n  border-radius: 5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/lagerartikelzeile/lagerartikelzeile.component.css
// module id = ../../../../../src/app/lagerartikelzeile/lagerartikelzeile.component.css
// module chunks = 1